import classNames from "classnames";
import { CampaignsTable } from "./components/Tables";
import { SliderKey } from "./components/Slider";
import { useAdsAnaliticsStore } from "src/store/ads-analitics.store";
import { AdSpend } from "../../../../components/AdSpend";
import { WhatIfCharts } from "./components/WhatIfCharts";
import { useMaintenance } from "src/store/maintenance.state";
import { ExecutiveSummary } from "@components/ExecutiveSummary";
import SalesPerformance from "@components/SalesPerformance";
import styles from "./styles.module.scss";
import { useMaintenanceDev } from "src/store/maintenanceDev.state";
import FlowProgressLineSecond from "@components/FlowProgressLineSecond";
import { ActiveStepStore } from "src/store/onboarding.store";
import FlowProgressLine from "@components/FlowProgressLine";
import { useState } from "react";

interface CampaignsProps {
  canvas?: boolean;
}

export const Campaigns: React.FC<CampaignsProps> = ({ canvas = false }) => {
  const { isWhatIfEnabled } = useAdsAnaliticsStore((state) => ({
    isWhatIfEnabled: state.isWhatIfEnabled,
  }));

  const [showSlider, setShowSlider] = useState(false);

  const { maintenance } = useMaintenance();
  const { maintenanceDev } = useMaintenanceDev();

  const step = ActiveStepStore((state) => state.step);
  const setStep = ActiveStepStore((state) => state.setStep);

  return (
    <div className={styles.container}>
      {maintenance &&
        (step <= 4 ? (
          <div className={styles.sharegoal}>
            <FlowProgressLine setActiveStep={setStep} activeStep={step} />
          </div>
        ) : (
          <div className={styles.sharegoal}>
            <h2>Improve Market Share Goal: $15M → $17M</h2>
            <FlowProgressLineSecond activeStep={step} />
          </div>
        ))}

      <div className={classNames({ [styles.hidden]: canvas })}>
        {!isWhatIfEnabled && <SliderKey />}
      </div>

      <div className={styles.metrics}>
        <ExecutiveSummary
          hideSwitch
          showOnly="Ad"
          showWhatIf={isWhatIfEnabled}
        />
        <div className={classNames(styles.chart, styles.box)}>
          <SalesPerformance choosedGroups={["Ad"]} />
        </div>
      </div>
      <div className={classNames({ [styles.hidden]: canvas }, styles.products)}>
        {isWhatIfEnabled && (
          <>
            {showSlider && <SliderKey />}
            <AdSpend setShow={setShowSlider} />
          </>
        )}
        <CampaignsTable isWhatIf={isWhatIfEnabled} />
        {isWhatIfEnabled && maintenance && !maintenanceDev && <WhatIfCharts />}
      </div>
    </div>
  );
};
